/* tslint:disable */
/* eslint-disable */
/**
 * Green0meter API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { AssessmentDto } from '../models';
// @ts-ignore
import type { AssessmentQuestionCountDto } from '../models';
// @ts-ignore
import type { CreateAssessmentDto } from '../models';
// @ts-ignore
import type { DoubleMaterialityAssessmentsControllerGetAllAssessments200Response } from '../models';
// @ts-ignore
import type { UpdateAssessmentDto } from '../models';
/**
 * DoubleMaterialityAssessmentsApi - axios parameter creator
 * @export
 */
export const DoubleMaterialityAssessmentsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateAssessmentDto} createAssessmentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doubleMaterialityAssessmentsControllerCreateAssessment: async (createAssessmentDto: CreateAssessmentDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createAssessmentDto' is not null or undefined
            assertParamExists('doubleMaterialityAssessmentsControllerCreateAssessment', 'createAssessmentDto', createAssessmentDto)
            const localVarPath = `/api/dm/assessments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createAssessmentDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {boolean} [deleteQuestions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doubleMaterialityAssessmentsControllerDeleteAssessment: async (id: string, deleteQuestions?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('doubleMaterialityAssessmentsControllerDeleteAssessment', 'id', id)
            const localVarPath = `/api/dm/assessments/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (deleteQuestions !== undefined) {
                localVarQueryParameter['deleteQuestions'] = deleteQuestions;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} year Reporting year for the double materiality data
         * @param {string | null} [search] 
         * @param {string | null} [orderBy] 
         * @param {string | null} [orderDirection] 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doubleMaterialityAssessmentsControllerGetAllAssessments: async (year: number, search?: string | null, orderBy?: string | null, orderDirection?: string | null, pageNumber?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'year' is not null or undefined
            assertParamExists('doubleMaterialityAssessmentsControllerGetAllAssessments', 'year', year)
            const localVarPath = `/api/dm/assessments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['orderBy'] = orderBy;
            }

            if (orderDirection !== undefined) {
                localVarQueryParameter['orderDirection'] = orderDirection;
            }

            if (pageNumber !== undefined) {
                localVarQueryParameter['pageNumber'] = pageNumber;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} assessmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doubleMaterialityAssessmentsControllerGetAssessmentByAssessmentId: async (assessmentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assessmentId' is not null or undefined
            assertParamExists('doubleMaterialityAssessmentsControllerGetAssessmentByAssessmentId', 'assessmentId', assessmentId)
            const localVarPath = `/api/dm/assessments/assessmentId/{assessmentId}`
                .replace(`{${"assessmentId"}}`, encodeURIComponent(String(assessmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doubleMaterialityAssessmentsControllerGetAssessmentById: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('doubleMaterialityAssessmentsControllerGetAssessmentById', 'id', id)
            const localVarPath = `/api/dm/assessments/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doubleMaterialityAssessmentsControllerGetAssessmentQuestionCount: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('doubleMaterialityAssessmentsControllerGetAssessmentQuestionCount', 'id', id)
            const localVarPath = `/api/dm/assessments/{id}/question-count`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateAssessmentDto} updateAssessmentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doubleMaterialityAssessmentsControllerUpdateAssessment: async (id: string, updateAssessmentDto: UpdateAssessmentDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('doubleMaterialityAssessmentsControllerUpdateAssessment', 'id', id)
            // verify required parameter 'updateAssessmentDto' is not null or undefined
            assertParamExists('doubleMaterialityAssessmentsControllerUpdateAssessment', 'updateAssessmentDto', updateAssessmentDto)
            const localVarPath = `/api/dm/assessments/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateAssessmentDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DoubleMaterialityAssessmentsApi - functional programming interface
 * @export
 */
export const DoubleMaterialityAssessmentsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DoubleMaterialityAssessmentsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CreateAssessmentDto} createAssessmentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async doubleMaterialityAssessmentsControllerCreateAssessment(createAssessmentDto: CreateAssessmentDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssessmentDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.doubleMaterialityAssessmentsControllerCreateAssessment(createAssessmentDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DoubleMaterialityAssessmentsApi.doubleMaterialityAssessmentsControllerCreateAssessment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {boolean} [deleteQuestions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async doubleMaterialityAssessmentsControllerDeleteAssessment(id: string, deleteQuestions?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.doubleMaterialityAssessmentsControllerDeleteAssessment(id, deleteQuestions, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DoubleMaterialityAssessmentsApi.doubleMaterialityAssessmentsControllerDeleteAssessment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} year Reporting year for the double materiality data
         * @param {string | null} [search] 
         * @param {string | null} [orderBy] 
         * @param {string | null} [orderDirection] 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async doubleMaterialityAssessmentsControllerGetAllAssessments(year: number, search?: string | null, orderBy?: string | null, orderDirection?: string | null, pageNumber?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DoubleMaterialityAssessmentsControllerGetAllAssessments200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.doubleMaterialityAssessmentsControllerGetAllAssessments(year, search, orderBy, orderDirection, pageNumber, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DoubleMaterialityAssessmentsApi.doubleMaterialityAssessmentsControllerGetAllAssessments']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} assessmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async doubleMaterialityAssessmentsControllerGetAssessmentByAssessmentId(assessmentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssessmentDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.doubleMaterialityAssessmentsControllerGetAssessmentByAssessmentId(assessmentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DoubleMaterialityAssessmentsApi.doubleMaterialityAssessmentsControllerGetAssessmentByAssessmentId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async doubleMaterialityAssessmentsControllerGetAssessmentById(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssessmentDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.doubleMaterialityAssessmentsControllerGetAssessmentById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DoubleMaterialityAssessmentsApi.doubleMaterialityAssessmentsControllerGetAssessmentById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async doubleMaterialityAssessmentsControllerGetAssessmentQuestionCount(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssessmentQuestionCountDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.doubleMaterialityAssessmentsControllerGetAssessmentQuestionCount(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DoubleMaterialityAssessmentsApi.doubleMaterialityAssessmentsControllerGetAssessmentQuestionCount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateAssessmentDto} updateAssessmentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async doubleMaterialityAssessmentsControllerUpdateAssessment(id: string, updateAssessmentDto: UpdateAssessmentDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssessmentDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.doubleMaterialityAssessmentsControllerUpdateAssessment(id, updateAssessmentDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DoubleMaterialityAssessmentsApi.doubleMaterialityAssessmentsControllerUpdateAssessment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DoubleMaterialityAssessmentsApi - factory interface
 * @export
 */
export const DoubleMaterialityAssessmentsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DoubleMaterialityAssessmentsApiFp(configuration)
    return {
        /**
         * 
         * @param {CreateAssessmentDto} createAssessmentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doubleMaterialityAssessmentsControllerCreateAssessment(createAssessmentDto: CreateAssessmentDto, options?: RawAxiosRequestConfig): AxiosPromise<AssessmentDto> {
            return localVarFp.doubleMaterialityAssessmentsControllerCreateAssessment(createAssessmentDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {boolean} [deleteQuestions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doubleMaterialityAssessmentsControllerDeleteAssessment(id: string, deleteQuestions?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.doubleMaterialityAssessmentsControllerDeleteAssessment(id, deleteQuestions, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} year Reporting year for the double materiality data
         * @param {string | null} [search] 
         * @param {string | null} [orderBy] 
         * @param {string | null} [orderDirection] 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doubleMaterialityAssessmentsControllerGetAllAssessments(year: number, search?: string | null, orderBy?: string | null, orderDirection?: string | null, pageNumber?: number, pageSize?: number, options?: RawAxiosRequestConfig): AxiosPromise<DoubleMaterialityAssessmentsControllerGetAllAssessments200Response> {
            return localVarFp.doubleMaterialityAssessmentsControllerGetAllAssessments(year, search, orderBy, orderDirection, pageNumber, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} assessmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doubleMaterialityAssessmentsControllerGetAssessmentByAssessmentId(assessmentId: string, options?: RawAxiosRequestConfig): AxiosPromise<AssessmentDto> {
            return localVarFp.doubleMaterialityAssessmentsControllerGetAssessmentByAssessmentId(assessmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doubleMaterialityAssessmentsControllerGetAssessmentById(id: string, options?: RawAxiosRequestConfig): AxiosPromise<AssessmentDto> {
            return localVarFp.doubleMaterialityAssessmentsControllerGetAssessmentById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doubleMaterialityAssessmentsControllerGetAssessmentQuestionCount(id: string, options?: RawAxiosRequestConfig): AxiosPromise<AssessmentQuestionCountDto> {
            return localVarFp.doubleMaterialityAssessmentsControllerGetAssessmentQuestionCount(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateAssessmentDto} updateAssessmentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doubleMaterialityAssessmentsControllerUpdateAssessment(id: string, updateAssessmentDto: UpdateAssessmentDto, options?: RawAxiosRequestConfig): AxiosPromise<AssessmentDto> {
            return localVarFp.doubleMaterialityAssessmentsControllerUpdateAssessment(id, updateAssessmentDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DoubleMaterialityAssessmentsApi - object-oriented interface
 * @export
 * @class DoubleMaterialityAssessmentsApi
 * @extends {BaseAPI}
 */
export class DoubleMaterialityAssessmentsApi extends BaseAPI {
    /**
     * 
     * @param {CreateAssessmentDto} createAssessmentDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DoubleMaterialityAssessmentsApi
     */
    public doubleMaterialityAssessmentsControllerCreateAssessment(createAssessmentDto: CreateAssessmentDto, options?: RawAxiosRequestConfig) {
        return DoubleMaterialityAssessmentsApiFp(this.configuration).doubleMaterialityAssessmentsControllerCreateAssessment(createAssessmentDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {boolean} [deleteQuestions] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DoubleMaterialityAssessmentsApi
     */
    public doubleMaterialityAssessmentsControllerDeleteAssessment(id: string, deleteQuestions?: boolean, options?: RawAxiosRequestConfig) {
        return DoubleMaterialityAssessmentsApiFp(this.configuration).doubleMaterialityAssessmentsControllerDeleteAssessment(id, deleteQuestions, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} year Reporting year for the double materiality data
     * @param {string | null} [search] 
     * @param {string | null} [orderBy] 
     * @param {string | null} [orderDirection] 
     * @param {number} [pageNumber] 
     * @param {number} [pageSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DoubleMaterialityAssessmentsApi
     */
    public doubleMaterialityAssessmentsControllerGetAllAssessments(year: number, search?: string | null, orderBy?: string | null, orderDirection?: string | null, pageNumber?: number, pageSize?: number, options?: RawAxiosRequestConfig) {
        return DoubleMaterialityAssessmentsApiFp(this.configuration).doubleMaterialityAssessmentsControllerGetAllAssessments(year, search, orderBy, orderDirection, pageNumber, pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} assessmentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DoubleMaterialityAssessmentsApi
     */
    public doubleMaterialityAssessmentsControllerGetAssessmentByAssessmentId(assessmentId: string, options?: RawAxiosRequestConfig) {
        return DoubleMaterialityAssessmentsApiFp(this.configuration).doubleMaterialityAssessmentsControllerGetAssessmentByAssessmentId(assessmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DoubleMaterialityAssessmentsApi
     */
    public doubleMaterialityAssessmentsControllerGetAssessmentById(id: string, options?: RawAxiosRequestConfig) {
        return DoubleMaterialityAssessmentsApiFp(this.configuration).doubleMaterialityAssessmentsControllerGetAssessmentById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DoubleMaterialityAssessmentsApi
     */
    public doubleMaterialityAssessmentsControllerGetAssessmentQuestionCount(id: string, options?: RawAxiosRequestConfig) {
        return DoubleMaterialityAssessmentsApiFp(this.configuration).doubleMaterialityAssessmentsControllerGetAssessmentQuestionCount(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {UpdateAssessmentDto} updateAssessmentDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DoubleMaterialityAssessmentsApi
     */
    public doubleMaterialityAssessmentsControllerUpdateAssessment(id: string, updateAssessmentDto: UpdateAssessmentDto, options?: RawAxiosRequestConfig) {
        return DoubleMaterialityAssessmentsApiFp(this.configuration).doubleMaterialityAssessmentsControllerUpdateAssessment(id, updateAssessmentDto, options).then((request) => request(this.axios, this.basePath));
    }
}

